/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AvaliacaoResponse,
  AvaliarMaterialDto,
  ErroResponse,
  EventoRegistradoResponse,
  ListaDaVitrineResponse,
  ParceiroDetalheResponse,
  ParceirosControllerListarParams,
  RegistrarEventoDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getParceirosControllerListarUrl = (params?: ParceirosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/parceiros?${stringifiedParams}` : `/v1/parceiros`
}

/**
 * @summary Vitrine: parceiros ativos, ordenados, com as categorias do filtro
 */
export const parceirosControllerListar = async (params?: ParceirosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<ListaDaVitrineResponse> => {

  return httpClient<ListaDaVitrineResponse>(getParceirosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getParceirosControllerListarQueryKey = (params?: ParceirosControllerListarParams,) => {
    return [
    `/v1/parceiros`, ...(params ? [params] : [])
    ] as const;
    }


export const getParceirosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof parceirosControllerListar>>, TError = ErroResponse>(params?: ParceirosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParceirosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof parceirosControllerListar>>> = ({ signal }) => parceirosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParceirosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof parceirosControllerListar>>>
export type ParceirosControllerListarQueryError = ErroResponse


export function useParceirosControllerListar<TData = Awaited<ReturnType<typeof parceirosControllerListar>>, TError = ErroResponse>(
 params: undefined |  ParceirosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof parceirosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosControllerListar<TData = Awaited<ReturnType<typeof parceirosControllerListar>>, TError = ErroResponse>(
 params?: ParceirosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof parceirosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosControllerListar<TData = Awaited<ReturnType<typeof parceirosControllerListar>>, TError = ErroResponse>(
 params?: ParceirosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Vitrine: parceiros ativos, ordenados, com as categorias do filtro
 */

export function useParceirosControllerListar<TData = Awaited<ReturnType<typeof parceirosControllerListar>>, TError = ErroResponse>(
 params?: ParceirosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParceirosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getParceirosControllerObterUrl = (id: string,) => {




  return `/v1/parceiros/${id}`
}

/**
 * @summary Detalha um parceiro, com materiais APROVADOS e produtos ativos
 */
export const parceirosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ParceiroDetalheResponse> => {

  return httpClient<ParceiroDetalheResponse>(getParceirosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getParceirosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/parceiros/${id}`
    ] as const;
    }


export const getParceirosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof parceirosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getParceirosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof parceirosControllerObter>>> = ({ signal }) => parceirosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ParceirosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof parceirosControllerObter>>>
export type ParceirosControllerObterQueryError = ErroResponse


export function useParceirosControllerObter<TData = Awaited<ReturnType<typeof parceirosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof parceirosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosControllerObter<TData = Awaited<ReturnType<typeof parceirosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof parceirosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof parceirosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useParceirosControllerObter<TData = Awaited<ReturnType<typeof parceirosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um parceiro, com materiais APROVADOS e produtos ativos
 */

export function useParceirosControllerObter<TData = Awaited<ReturnType<typeof parceirosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof parceirosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getParceirosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getParceirosControllerRegistrarEventoUrl = (id: string,) => {




  return `/v1/parceiros/${id}/eventos`
}

/**
 * @summary Registra impressão ou clique. Deduplicado por janela de 30 min.
 */
export const parceirosControllerRegistrarEvento = async (id: string,
    registrarEventoDto: RegistrarEventoDto, options?: Parameters<typeof httpClient>[1]): Promise<EventoRegistradoResponse> => {

  return httpClient<EventoRegistradoResponse>(getParceirosControllerRegistrarEventoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registrarEventoDto)
  }
);}





export const getParceirosControllerRegistrarEventoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosControllerRegistrarEvento>>, TError,{id: string;data: RegistrarEventoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosControllerRegistrarEvento>>, TError,{id: string;data: RegistrarEventoDto}, TContext> => {

const mutationKey = ['parceirosControllerRegistrarEvento'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosControllerRegistrarEvento>>, {id: string;data: RegistrarEventoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  parceirosControllerRegistrarEvento(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosControllerRegistrarEventoMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosControllerRegistrarEvento>>>
    export type ParceirosControllerRegistrarEventoMutationBody = RegistrarEventoDto
    export type ParceirosControllerRegistrarEventoMutationError = ErroResponse

    /**
 * @summary Registra impressão ou clique. Deduplicado por janela de 30 min.
 */
export const useParceirosControllerRegistrarEvento = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosControllerRegistrarEvento>>, TError,{id: string;data: RegistrarEventoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosControllerRegistrarEvento>>,
        TError,
        {id: string;data: RegistrarEventoDto},
        TContext
      > => {
      return useMutation(getParceirosControllerRegistrarEventoMutationOptions(options), queryClient);
    }
    export const getParceirosControllerAvaliarUrl = (materialId: string,) => {




  return `/v1/parceiros/materiais/${materialId}/avaliacao`
}

/**
 * @summary Dá ou atualiza a nota do usuário para um material aprovado
 */
export const parceirosControllerAvaliar = async (materialId: string,
    avaliarMaterialDto: AvaliarMaterialDto, options?: Parameters<typeof httpClient>[1]): Promise<AvaliacaoResponse> => {

  return httpClient<AvaliacaoResponse>(getParceirosControllerAvaliarUrl(materialId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(avaliarMaterialDto)
  }
);}





export const getParceirosControllerAvaliarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosControllerAvaliar>>, TError,{materialId: string;data: AvaliarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof parceirosControllerAvaliar>>, TError,{materialId: string;data: AvaliarMaterialDto}, TContext> => {

const mutationKey = ['parceirosControllerAvaliar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof parceirosControllerAvaliar>>, {materialId: string;data: AvaliarMaterialDto}> = (props) => {
          const {materialId,data} = props ?? {};

          return  parceirosControllerAvaliar(materialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ParceirosControllerAvaliarMutationResult = NonNullable<Awaited<ReturnType<typeof parceirosControllerAvaliar>>>
    export type ParceirosControllerAvaliarMutationBody = AvaliarMaterialDto
    export type ParceirosControllerAvaliarMutationError = ErroResponse

    /**
 * @summary Dá ou atualiza a nota do usuário para um material aprovado
 */
export const useParceirosControllerAvaliar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof parceirosControllerAvaliar>>, TError,{materialId: string;data: AvaliarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof parceirosControllerAvaliar>>,
        TError,
        {materialId: string;data: AvaliarMaterialDto},
        TContext
      > => {
      return useMutation(getParceirosControllerAvaliarMutationOptions(options), queryClient);
    }
